import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260831_remove_builder_ref_and_option_set_ref_tables",
  description: "Remove the builderRefs and optionSetRefs tables, which pointed at the legacy option catalog",
  apply(json: any) {
    // migration_0_0_317 moved these under lastSessionInfo, but docDefault kept seeding
    // the top-level pair, so both locations can be present.
    delete json.builderRefs;
    delete json.optionSetRefs;
    if (json.lastSessionInfo) {
      delete json.lastSessionInfo.builderRefs;
      delete json.lastSessionInfo.optionSetRefs;
    }
    return json;
  },
};

export default migration;
